module.exports = __webpack_public_path__ + "img/htpangebg.bf8dd994.png";